<script>
import axios from 'axios'
import LocalForage from 'localforage';
import MainDepartment from './MainDepartment.vue'

export default {
  props: {
    params: Object,
  },
  data() {
    return {
      type: 'login',
      loading: false,
      loadingText: '',
      partner: window.localStorage.getItem('partner'),
      partnerName: window.localStorage.getItem('partnerName'),
      department: '',
      form: {
        partnerId: window.localStorage.getItem('partner'),
        login: '',
        password: '',
        new_password: '',
        newPasswordAgain: '',
        email: '',
      },
      rules: {
        partnerId: [
          { required: true, message: 'Пожалуйста введите id партнера', trigger: ['blur', 'change'] },
        ],
        login: [
          { required: true, message: 'Пожалуйста введите логин', trigger: ['blur', 'change'] },
        ],
        // password: [
        //   {required: true, message: 'Пожалуйста введите пароль', trigger: ['blur', 'change']},
        // ],
        new_password: [
          { required: true, message: 'Пожалуйста введите новый пароль', trigger: ['blur', 'change'] },
        ],
        newPasswordAgain: [
          { required: true, message: 'Пожалуйста повторите новый пароль', trigger: ['blur', 'change'] },
        ],
        email: [
          { required: true, message: 'Пожалуйста введите email', trigger: 'blur' },
          { type: 'email', message: 'Пожалуйста введите корректный email', trigger: ['blur', 'change'] }
        ],
      }
    }
  },
  methods: {
    click_repassword() {
      this.type = 'rePassword'
    },
    click_login() {
      this.type = 'login'
    },
    change_department(v) {
      if (v) {
        this.location();
      } else {
        this.department = '';
        this.loading_false();
      }
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.loading_true();
        switch (this.type) {
          case 'login':
            this.submit_login(
              {
                partnerId: this.form.partnerId,
                login: this.form.login,
                password: this.form.password,
              })
              .then(() => {
                this.location();
              })
              .catch(() => {
                this.loading_false();
              });
            break;
          case 'newPassword':
            if (this.form.newPasswordAgain !== this.form.new_password) {
              MAG.app.$notify.error({
                title: 'Ошибка',
                message: 'Пароли не совпадают'
              });
              this.loading_false();
              return;
            }
            this.submit_login(
              {
                partnerId: this.form.partnerId,
                login: this.form.login,
                password: this.form.password,
                newPassword: this.form.new_password,
              })
              .then(() => {
                this.location();
              })
              .catch(() => {
                this.loading_false();
              });
            break;
          case 'rePassword':
            this.submit_rePassword()
              .then(() => {
                this.loading_false();
                this.type = 'login';
              })
              .catch(() => {
                this.loading_false();
              });
            break;
        }
      });
    },
    loading_true() {
      this.loadingText = '';
      this.loading = true;
      setTimeout(
        setTimeout(() => {
          this.loadingText = 'Внимание. Идет загрузка справочных данных. Немного подождите';
        }, 2000)
      );
    },
    loading_false() {
      this.loading = false;
      this.loadingText = '';
    },
    location() {
      window.location.href = this.params['ret'] ? this.params['ret'] : '/tourclient/admin/';
    },
    submit_login(data) {
      LocalForage.keys()
        .then(keys => Promise.all(keys.map(i => LocalForage.removeItem(i))));
      return new Promise((resolve, reject) => {
        axios.post(
          '/tourclient/account/loginajax',
          data
        ).then(
          ({ data }) => {
            switch (data.Status) {
              case null:
              case 0:
                if (window.api) window.api.clear();
                window.localStorage.setItem('partner', data.UserData.PartnerId);
                window.localStorage.setItem('partnerName', data.UserData.PartnerName ? data.UserData.PartnerName : '');
                if (data.UserData.NeedSelectDepartment) {
                  this.department = data.UserData.DepartmentId;
                  if (data.UserData.InvalidateOtherUser) {
                    MAG.app.$notify.error({
                      message: 'Сессия на другом устройстве/браузере была принудительно закончена'
                    });
                  }

                    this.loading_false();
                } else if (data.UserData.InvalidateOtherUser) {
                  MAG.app.$notify.error({
                    message: 'Сессия на другом устройстве/браузере была принудительно закончена'
                  });
                  setTimeout(() => {
                    resolve(data);
                  }, 3000);
                } else {
                  resolve(data);
                }
                break;
              case 2:
                MAG.app.$notify.error({
                  title: 'Ошибка',
                  message: 'Превышено максимальное количество активных подключений'
                });
                reject();
                break;
              case 3:
                MAG.app.$notify.error({
                  title: 'Ошибка',
                  message: 'Некорректный логин и/или пароль'
                });
                reject();
                break;
              case 4:
                MAG.app.$notify.error({
                  title: 'Ошибка',
                  message: 'Некорректный ID партнера'
                });
                reject();
                break;
              case 5:
                MAG.app.$notify.error({
                  title: 'Ошибка',
                  message: 'Вам запрещен вход в систему'
                });
                reject();
                break;
              case 6:
                this.type = 'newPassword';
                MAG.app.$notify.warning({
                  title: 'Внимание',
                  message: 'Необходимо указать новый пароль'
                });
                this.loading_false();
                break;
              default:
                if (data.Message) {
                  MAG.app.$notify.error({
                    title: 'Ошибка',
                    message: data.Message
                  });
                  reject();
                } else {
                  resolve(data);
                }
            }
          },
          err => {
            if (axios.isCancel(err)) return;
            if (err.response) {
              switch (err.response.status) {
                case 0:
                case 401:
                  return;
                default: {
                  MAG.app.$notify.error({
                    title: 'Ошибка',
                    message: 'В данный момент ведутся работы, попробуйте войти немного позже'
                  });
                  reject();
                }
              }
            }
          }
        )
      })
    },
    submit_rePassword() {
      return new Promise((resolve, reject) => {
        axios.post(
          '/tourclient/account/restorePass',
          {
            partnerId: this.form.partnerId,
            login: this.form.login,
            email: this.form.email,
          }
        ).then(
          ({ data }) => {
            if (data.IsSuccess) {
              MAG.app.$notify.success({
                title: 'Восстановление пароля',
                message: data.Message
              });
              resolve(data);
            } else {
              MAG.app.$notify.error({
                title: 'Ошибка',
                message: data.Message
              });
              reject();
            }
          },
          err => {
            MAG.app.$notify.error({
              title: 'Ошибка',
              message: 'В данный момент ведутся работы, попробуйте войти немного позже'
            });
            reject();
          }
        )
      })
    },
  },
  computed: {
    title() {
      switch (this.type) {
        case 'login':
        case 'newPassword':
          return 'Вход в систему';
        case 'rePassword':
          return 'Восстановление пароля';
        default:
          return 'Вход в систему';
      }
    },
    submit_label() {
      switch (this.type) {
        case 'login':
        case 'newPassword':
          return 'Войти';
        case 'rePassword':
          return 'Отправить';
        default:
          return 'Войти';
      }
    },
  },
  watch: {},
  components: {
    MainDepartment
  },
  mounted() {
    this.$el.querySelector('input[name="partnerId"]').focus();
    if (this.params['agency']) {
      this.form.partnerId = this.params['agency'];
      this.partner = '';
      this.partnerName = '';
    }
  },
  destroyed() {
  }
}
</script>
<template>
  <div class="main"
       v-loading="loading"
       :element-loading-text="loadingText"
       element-loading-background="#ececec">
    <h1><span v-if="partnerName&&partner===form.partnerId">{{partnerName}}</span><span v-else>{{title}}</span></h1>
    <div class="wrap">
      <div class="main__box">
        <div class="main__bg"></div>
        <div class="main__body">
          <div class="main__form" @keyup.enter="submit">
            <el-form :model="form" ref="form" :rules="rules">
              <el-form-item prop="partnerId">
                <el-input v-model="form.partnerId" name="partnerId" placeholder="Id партнера"></el-input>
              </el-form-item>
              <el-form-item prop="login">
                <el-input v-model="form.login" name="login" placeholder="Введите ваш логин"></el-input>
              </el-form-item>
              <el-form-item prop="password" key="password" v-if="type==='login'">
                <el-input v-model="form.password" type="password" name="password"
                          placeholder="Введите ваш пароль"></el-input>
              </el-form-item>
              <el-form-item prop="new_password" key="new_password" v-if="type==='newPassword'">
                <el-input v-model="form.new_password" type="password" name="new_password"
                          placeholder="Введите новый пароль"></el-input>
              </el-form-item>
              <el-form-item prop="newPasswordAgain" key="newPasswordAgain" v-if="type==='newPassword'">
                <el-input v-model="form.newPasswordAgain" type="password" name="newPasswordAgain"
                          placeholder="Повторите новый пароль"></el-input>
              </el-form-item>
              <el-form-item prop="email" key="email" v-if="type==='rePassword'">
                <el-input v-model="form.email" name="email" placeholder="Введите ваш email"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="main__buttons">
            <div class="main__links">
              <a href="/tourclient/spa/#/registration" tabindex="-1">Регистрация</a>
              <span @click="click_repassword" v-if="type==='login'">Забыли пароль?</span>
              <span @click="click_login" v-if="type!=='login'">Вход в систему</span>
            </div>
            <div class="main__submit">
              <el-button type="primary" @click="submit" style="">{{submit_label}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MainDepartment @change="change_department" :department="department" v-if="department||department===0"/>
  </div>
</template>
